import { combineReducers } from 'redux';
import Checkin from './checkin';
import FireBaseUserReducer from './firebase_user_reducer';
import Itinerary from './itinerary';

const rootReducer = combineReducers({
    checkins: Checkin,
    currentUser: FireBaseUserReducer,
    itinerary: Itinerary
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/app/reducers/index.js